/**
 * Phase 7: Initialize Performance Tracking
 * Sets up Core Web Vitals monitoring on app load
 */

import { performanceMonitor } from '@/services/PerformanceMonitorService';

let initialized = false;

export const initPerformanceTracking = () => {
  if (initialized || typeof window === 'undefined') return;
  
  initialized = true;
  
  console.log('📊 [Performance] Initializing Core Web Vitals tracking...');
  
  // Start tracking web vitals
  performanceMonitor.trackWebVitals();
  
  // Check performance budget every 30 seconds
  setInterval(() => {
    performanceMonitor.checkPerformanceBudget();
  }, 30000);
  
  // Log initial report after 5 seconds
  setTimeout(() => {
    performanceMonitor.logReport();
  }, 5000);
  
  console.log('✅ [Performance] Tracking initialized');
};
